<template>
  <rpm-input
    :label="!noLabel ? question.label:''"
    :required="!noLabel ? question.required:''"
    :optional="!noLabel ? !question.required:''"
    class="w-full"
    v-mask="question.mask"
  ></rpm-input>
</template>

<script>
export default {
  name: "TextAnswer",
  props: {
    question: {
      type: Object,
      required: true
    },
    noLabel: {
      type: Boolean,
      default: false
    },
  },
};
</script>
